export function incrementJalaliMonth(jalaliYearMonth: string) {
  let [jy, jm] = jalaliYearMonth.split('-').map(Number);

  if (!jy || !jm) throw new Error('Invalid Jalali year-month');

  jm += 1;

  if (jm > 12) {
    jm = 1;
    jy += 1;
  }

  return `${jy}-${String(jm).padStart(2, '0')}`;
}

export function decrementJalaliMonth(jalaliYearMonth: string) {
  let [jy, jm] = jalaliYearMonth.split('-').map(Number);

  if (!jy || !jm) throw new Error('Invalid Jalali year-month');

  jm -= 1;

  if (jm < 1) {
    jm = 12;
    jy -= 1;
  }

  return `${jy}-${String(jm)}`;
}

export function incrementJalaliYear(jalaliYearMonth: string) {
  let [jy, jm] = jalaliYearMonth.split('-').map(Number);

  if (!jy || !jm) throw new Error('Invalid Jalali year-month');

  jy += 1;

  return `${jy}-${String(jm).padStart(2, '0')}`;
}
